import './styles/main.scss'; // Don't delete this, otherwise css bundle will not be generated

import 'isomorphic-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router';
import {IntlProvider} from 'react-intl';
import {polyfill} from 'es6-promise';
polyfill();
import {getPolyfill} from 'object.assign';
if (typeof Object.assign !== 'function') {
  Object.assign = getPolyfill();
}

// Only IE 10 and safari 9 do not support Intl
import IntlPolyfill from 'intl';
import 'intl/locale-data/jsonp/en.js';
if (typeof window.Intl !== 'object') {
  window.Intl = IntlPolyfill;
}

import createRoutes from './routes';
import createStore from './create-store';
import fetchData from './fetch-data';
import {setClientTopology, setGetClientState} from './config';
import {createHistory} from './services/history';
import {updateBIFields, initBI} from './services/bi-events-manager';

setClientTopology(window.__CONFIG__);

const store = createStore(window.__INITIAL_STATE__);
setGetClientState(store.getState);
const routes = createRoutes(store);
const currentState = store.getState();
const history = createHistory(currentState.mode.baseUrl);
initBI(currentState);

history.listen((ev) => {
  updateBIFields(store.getState(), ev);
});
updateBIFields(store.getState(), history.getCurrentLocation());

function onUpdate() {
  if (window.__INITIAL_STATE__ !== null) {
    return window.__INITIAL_STATE__ = null;
  }

  const {components, params, location} = this.state;

  return fetchData(store.dispatch, components, params, location);
}

ReactDOM.render(
  <IntlProvider locale="en" messages={window.__TRANSLATIONS__}>
    <Provider store={store}>
      <Router history={history} onUpdate={onUpdate}>
        {routes}
      </Router>
    </Provider>
  </IntlProvider>,
  document.getElementById('app-market-root')
);



// for debug
// const renderStore = () => {
//   console.log('getState', store.getState());
// };
// store.subscribe(renderStore);
// renderStore();
window.debugReduxState = () => store.getState();



// WEBPACK FOOTER //
// ./client.js